<template>
  <p class="text-caption">
    {{ i18n.t('stationSummary.intro', { placeName: props.placeName, stateCode: props.stateCode.toUpperCase() }) }}
    <span v-if="placeName !== stationName">{{ i18n.t('stationSummary.atStationname', { stationName: props.stationName }) }}</span>
    {{ i18n.t('stationSummary.between', { fromDate: i18n.d(props.fromDate, 'full', i18n.locale.value),
                                          toDate: i18n.d(props.toDate, 'full', i18n.locale.value)}) }}
  </p>
</template>
<script lang="ts" setup>
/** TODO
* Replace date handling with vue handler
 */

import {useI18n} from "vue-i18n";
const i18n = useI18n()

// eslint ignore-next-line no-unused-vars
const props = defineProps({
  placeName: {
    type: String,
    default: null,
  },
  stateCode: {
    type: String,
    default: null,
  },
  stationName: {
    type: String,
    default: null,
  },
  fromDate: Date,
  toDate: Date,
});
</script>
<script lang="ts">
export default {
  name: "StationSummary",
};
</script>
